import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "overlay"];

  connect() {
    // Close sidebar when pressing Escape key
    document.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this));
  }

  toggle() {
    this.sidebarTarget.classList.toggle("-translate-x-full");
    this.overlayTarget.classList.toggle("hidden");

    // Prevent body scroll when sidebar is open
    document.body.style.overflow = this.sidebarTarget.classList.contains(
      "-translate-x-full",
    )
      ? ""
      : "hidden";
  }

  close() {
    this.sidebarTarget.classList.add("-translate-x-full");
    this.overlayTarget.classList.add("hidden");
    document.body.style.overflow = "";
  }

  handleKeydown(event) {
    if (
      event.key === "Escape" &&
      !this.sidebarTarget.classList.contains("-translate-x-full")
    ) {
      this.close();
    }
  }
}
